// ============================================
// Tienda Focus — Shopify Theme JS
// Usa Shopify AJAX Cart API (no localStorage)
// ============================================

let isCartOpen = false;
let isMobileMenuOpen = false;

// ─── DOM Ready ─────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initSearch();
  initCartPanel();
  initMobileMenu();
  initAnimations && initAnimations();
  initCountdown();
  refreshCartDrawer();
});

// ─── Header scroll ─────────────────────────
function initHeader() {
  const header = document.getElementById('main-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// ─── Mobile Menu ───────────────────────────
function initMobileMenu() {
  const toggle = document.getElementById('mobile-menu-toggle');
  const menu = document.getElementById('nav-menu');
  if (!toggle) return;
  toggle.addEventListener('click', () => {
    isMobileMenuOpen = !isMobileMenuOpen;
    toggle.classList.toggle('active', isMobileMenuOpen);
    menu && menu.classList.toggle('open', isMobileMenuOpen);
  });
  document.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', () => {
      isMobileMenuOpen = false;
      toggle.classList.remove('active');
      menu && menu.classList.remove('open');
    });
  });
}

// ─── Shopify AJAX Cart ─────────────────────

// Agrega un producto al carrito via AJAX
function addToCartShopify(variantId, productTitle) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(item => {
    const cartIcon = document.getElementById('cart-icon');
    if (cartIcon) {
      cartIcon.classList.add('cart-bounce');
      setTimeout(() => cartIcon.classList.remove('cart-bounce'), 600);
    }
    refreshCartDrawer();
    toggleCart(true);
  })
  .catch(err => {
    console.error('Error al agregar:', err);
    showToast('Error al agregar el producto');
  });
}

// Obtiene el carrito actual de Shopify
function getShopifyCart() {
  return fetch('/cart.js').then(r => r.json());
}

// Actualiza cantidad de un ítem
function updateShopifyQuantity(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  }).then(r => r.json());
}

// Refresca el drawer con datos actuales del carrito Shopify
function refreshCartDrawer() {
  getShopifyCart().then(cart => {
    updateCartBadge(cart.item_count);
    renderCartDrawer(cart);
  });
}

function updateCartBadge(count) {
  const badge = document.getElementById('cart-badge');
  if (!badge) return;
  badge.textContent = count;
  badge.style.display = count > 0 ? 'flex' : 'none';
}

function renderCartDrawer(cart) {
  const cartItems = document.getElementById('cart-items');
  const cartEmpty = document.getElementById('cart-empty');
  const cartFooter = document.getElementById('cart-footer');
  const cartTotal = document.getElementById('cart-total');
  if (!cartItems) return;

  if (cart.item_count === 0) {
    cartItems.innerHTML = '';
    if (cartEmpty) cartEmpty.style.display = 'flex';
    if (cartFooter) cartFooter.style.display = 'none';
    return;
  }

  if (cartEmpty) cartEmpty.style.display = 'none';
  if (cartFooter) cartFooter.style.display = 'block';

  cartItems.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img src="${item.image}" alt="${item.product_title}" class="cart-item-img">
      <div class="cart-item-info">
        <h4 class="cart-item-name">${item.product_title}</h4>
        ${item.variant_title !== 'Default Title' ? `<p style="font-size:.75rem;color:var(--text-muted)">${item.variant_title}</p>` : ''}
        <span class="cart-item-price">${formatMoney(item.price)}</span>
        <div class="cart-item-controls">
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})" aria-label="Disminuir">−</button>
          <span class="qty-value">${item.quantity}</span>
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})" aria-label="Aumentar">+</button>
          <button class="cart-item-remove" onclick="changeQty('${item.key}', 0)" aria-label="Eliminar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  `).join('');

  if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
}

function changeQty(key, qty) {
  updateShopifyQuantity(key, qty).then(cart => {
    updateCartBadge(cart.item_count);
    renderCartDrawer(cart);
  });
}

// ─── Cart Panel ────────────────────────────
function initCartPanel() {
  const cartBtn = document.getElementById('cart-btn');
  const cartOverlay = document.getElementById('cart-overlay');
  const closeCart = document.getElementById('close-cart');

  if (cartBtn) cartBtn.addEventListener('click', () => toggleCart());
  if (cartOverlay) cartOverlay.addEventListener('click', () => toggleCart(false));
  if (closeCart) closeCart.addEventListener('click', () => toggleCart(false));
}

function toggleCart(force) {
  isCartOpen = force !== undefined ? force : !isCartOpen;
  const panel = document.getElementById('cart-panel');
  const overlay = document.getElementById('cart-overlay');
  if (panel) panel.classList.toggle('open', isCartOpen);
  if (overlay) overlay.classList.toggle('open', isCartOpen);
  document.body.style.overflow = isCartOpen ? 'hidden' : '';
  if (isCartOpen) refreshCartDrawer();
}

// ─── Search Shopify ────────────────────────
function initSearch() {
  const searchInput = document.getElementById('search-input');
  const searchResults = document.getElementById('search-results');
  if (!searchInput) return;

  let debounceTimer;

  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const q = searchInput.value.trim();
      if (q.length < 2) {
        searchResults.classList.remove('active');
        searchResults.innerHTML = '';
        return;
      }
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`)
        .then(r => r.json())
        .then(data => {
          const products = data.resources?.results?.products || [];
          if (products.length === 0) {
            searchResults.innerHTML = '<div class="search-no-results">No se encontraron productos</div>';
            searchResults.classList.add('active');
            return;
          }
          searchResults.innerHTML = products.map(p => `
            <div class="search-result-item" onclick="window.location='${p.url}'">
              <img src="${p.featured_image?.url || ''}" alt="${p.title}" class="search-result-img">
              <div class="search-result-info">
                <span class="search-result-name">${p.title}</span>
                <span class="search-result-price">${formatMoney(p.price)}</span>
              </div>
            </div>
          `).join('');
          searchResults.classList.add('active');
        });
    }, 300);
  });

  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && searchInput.value.trim().length >= 2) {
      window.location = `${window.theme.searchUrl}?q=${encodeURIComponent(searchInput.value.trim())}&type=product`;
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.search-wrapper')) closeSearch();
  });
}

function closeSearch() {
  const r = document.getElementById('search-results');
  if (r) r.classList.remove('active');
}

// ─── Quick View Modal ──────────────────────
function openQuickView(productHandle) {
  fetch(`/products/${productHandle}.js`)
    .then(r => r.json())
    .then(product => {
      const modal = document.getElementById('quick-view-modal');
      const content = document.getElementById('quick-view-content');
      const hasDiscount = product.compare_at_price > product.price;
      const discount = hasDiscount
        ? Math.round((product.compare_at_price - product.price) / product.compare_at_price * 100)
        : 0;

      content.innerHTML = `
        <div class="qv-grid">
          <div class="qv-image">
            <img src="${product.featured_image}" alt="${product.title}">
          </div>
          <div class="qv-info">
            <span class="product-category-tag">${product.type || ''}</span>
            <h2 class="qv-name">${product.title}</h2>
            <div class="product-rating">
              <span class="star filled">★</span><span class="star filled">★</span>
              <span class="star filled">★</span><span class="star filled">★</span>
              <span class="star filled">★</span>
            </div>
            <div class="qv-price-row">
              <span class="qv-price">${formatMoney(product.price)}</span>
              ${hasDiscount ? `<span class="product-original-price">${formatMoney(product.compare_at_price)}</span>
              <span class="qv-discount">Ahorras ${formatMoney(product.compare_at_price - product.price)} (${discount}%)</span>` : ''}
            </div>
            <div class="qv-description">${product.description}</div>
            <button class="btn-add-cart btn-add-cart-lg" style="width:100%;margin-top:20px"
              onclick="addToCartShopify(${product.variants[0].id}, '${product.title.replace(/'/g, "\\'")}'); closeQuickView();">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
              Agregar al Carrito
            </button>
          </div>
        </div>
      `;
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
}

function closeQuickView() {
  const modal = document.getElementById('quick-view-modal');
  if (modal) modal.classList.remove('open');
  if (!isCartOpen) document.body.style.overflow = '';
}

// ─── WhatsApp ──────────────────────────────
function openWhatsApp() {
  getShopifyCart().then(cart => {
    let msg = cart.item_count > 0
      ? `¡Hola! Me interesan los siguientes productos:\n\n${cart.items.map(i => `• ${i.product_title} (x${i.quantity}) — ${formatMoney(i.price * i.quantity)}`).join('\n')}\n\nTotal: ${formatMoney(cart.total_price)}`
      : '¡Hola! Me gustaría consultar sobre sus productos.';
    const num = (window.theme && window.theme.whatsappNumber) || '56982728721';
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
  });
}

// ─── Toast ─────────────────────────────────
function showToast(message) {
  const container = document.getElementById('toast-container');
  if (!container) return;
  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
    <span>${message}</span>`;
  container.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('show'));
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// ─── Countdown ─────────────────────────────
function initCountdown() {
  const el = document.getElementById('promo-countdown');
  if (!el) return;
  const endStr = el.dataset.end;
  const end = endStr ? new Date(endStr) : new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);

  function render() {
    const diff = end - Date.now();
    if (diff <= 0) { el.innerHTML = '<p>¡Oferta terminada!</p>'; return; }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    el.innerHTML = `
      <div class="countdown-unit"><span class="countdown-number">${String(d).padStart(2,'0')}</span><span class="countdown-label">Días</span></div>
      <span class="countdown-separator">:</span>
      <div class="countdown-unit"><span class="countdown-number">${String(h).padStart(2,'0')}</span><span class="countdown-label">Horas</span></div>
      <span class="countdown-separator">:</span>
      <div class="countdown-unit"><span class="countdown-number">${String(m).padStart(2,'0')}</span><span class="countdown-label">Min</span></div>
      <span class="countdown-separator">:</span>
      <div class="countdown-unit"><span class="countdown-number">${String(s).padStart(2,'0')}</span><span class="countdown-label">Seg</span></div>`;
  }
  render();
  setInterval(render, 1000);
}

// ─── Format Money ──────────────────────────
function formatMoney(cents) {
  const amount = (cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 });
  return amount;
}

// ─── Render product card desde JS (para filtros AJAX) ─────
function renderProductCard(p, index) {
  // /products.json no trae price ni featured_image: vienen en variants (string en pesos) e images
  if (p.price === undefined && p.variants?.length) {
    p.price = Math.round(parseFloat(p.variants[0].price) * 100);
    p.compare_at_price = p.variants[0].compare_at_price ? Math.round(parseFloat(p.variants[0].compare_at_price) * 100) : null;
  }
  if (!p.featured_image && p.images?.length) p.featured_image = p.images[0].src;
  const hasDiscount = p.compare_at_price && p.compare_at_price > p.price;
  const discount = hasDiscount
    ? Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100)
    : 0;
  const badge = p.tags?.includes('nuevo') ? '<span class="product-badge badge-nuevo">Nuevo</span>'
    : p.tags?.includes('oferta') ? '<span class="product-badge badge-oferta">🔥 Oferta</span>'
    : p.tags?.includes('popular') ? '<span class="product-badge badge-popular">⭐ Popular</span>'
    : '';

  return `
    <div class="product-card" data-reveal="fade-up" data-reveal-delay="${index * 80}">
      <div class="product-image-wrapper">
        ${p.featured_image ? `<img src="${p.featured_image}" alt="${p.title}" class="product-image" loading="lazy">` : ''}
        ${badge}
        ${hasDiscount ? `<span class="product-discount-badge">-${discount}%</span>` : ''}
        <div class="product-overlay">
          <a href="/products/${p.handle}" class="btn-quick-view" aria-label="Ver producto">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
            </svg>
          </a>
        </div>
      </div>
      <div class="product-info">
        <span class="product-category-tag">${p.product_type || ''}</span>
        <h3 class="product-name"><a href="/products/${p.handle}" style="color:inherit">${p.title}</a></h3>
        <div class="product-rating">
          <span class="star filled">★</span><span class="star filled">★</span>
          <span class="star filled">★</span><span class="star filled">★</span><span class="star filled">★</span>
        </div>
        <div class="product-price-row">
          <span class="product-price">${formatMoney(p.price)}</span>
          ${hasDiscount ? `<span class="product-original-price">${formatMoney(p.compare_at_price)}</span>` : ''}
        </div>
        <button class="btn-add-cart" onclick="addToCartShopify(${p.variants[0].id}, '${p.title.replace(/'/g,"\\'")}')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          Agregar al carrito
        </button>
      </div>
    </div>`;
}

// ─── Scroll Reveal helper ──────────────────
function initReveal() {
  const items = document.querySelectorAll('[data-reveal]:not(.revealed)');
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const delay = e.target.dataset.revealDelay || 0;
        setTimeout(() => e.target.classList.add('revealed'), Number(delay));
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  items.forEach(el => obs.observe(el));
}
